export default __webpack_public_path__ + "static/media/539.6a48ce76.jpg";